import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getCookie } from "./utility-functions";
import { createCookie } from "./helpers";
import { LOCALE } from "./constants";

const useLanguageCode = () => {
  const location = useLocation();

  useEffect(() => {
    let languageCode = getCookie("languageCode");
    if (!languageCode) {
      const pathSegments = location.pathname.split("/");
      languageCode = pathSegments[2];
      if (
        languageCode &&
        (languageCode === LOCALE.ES || languageCode === LOCALE.EN)
      ) {
        createCookie("languageCode", languageCode, 1);
      } else {
        createCookie("languageCode", LOCALE.EN, 1);
      }
    }
  }, [location.pathname]);
};

export default useLanguageCode;
